import { format as formatDateFns } from 'date-fns';

export function parseISODateToLocal(isoDate: string): Date | null {
    if (!isoDate) return null;
    const dateOnly = isoDate.includes('T') ? isoDate.split('T')[0] : isoDate;
    const [year, month, day] = dateOnly.split('-').map(Number);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day);
}

export function formatDateMonthString(dateStr: string): string {
    if (!dateStr) return '';
    const date = parseISODateToLocal(dateStr);
    if (!date || isNaN(date.getTime())) return dateStr;
    return formatDateFns(date, 'MMMM d, yyyy');
}

export function formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = parseISODateToLocal(dateStr);
    if (!date || isNaN(date.getTime())) return dateStr;
    return formatDateFns(date, 'MM/dd/yyyy');
}

export function estimateAge(dateStr: string): string {
    if (!dateStr) return '';
    const date = parseISODateToLocal(dateStr);
    if (!date || isNaN(date.getTime())) return dateStr;
    const age = calculateAge(dateStr);
    return `(${age} years old)`;
}

export function calculateAge(dateOfBirth: string): number {
    const today = new Date();
    const birthDate = parseISODateToLocal(dateOfBirth);
    if (!birthDate) return 0;
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export function formatDateInput(input: string): string {
    const numbers = input.replace(/\D/g, '');
    if (numbers.length === 0) return '';
    if (numbers.length <= 2) return numbers;
    if (numbers.length <= 4) return `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
    return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4, 8)}`;
}

export function isValidDate(month: number, day: number, year: number): boolean {
    return month >= 1 && month <= 12 && day >= 1 && day <= 31 && year >= 1900 && year <= 2100;
}
